import React, { useEffect, useState } from 'react';
import './AdminPage.css';

// Фейковая «попытка входа», которая печатается построчно
const LINES = [
  '$ sudo ./admin --login',
  '[sudo] password for guest: ********',
  'checking credentials...',
  'bypassing firewall... ok',
  'escalating privileges... ok',
  'loading admin panel...',
];

export default function AdminPage() {
  const [shown, setShown] = useState(0);

  useEffect(() => {
    const prevTitle = document.title;
    document.title = 'admin';
    // Не индексировать страницу
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex';
    document.head.appendChild(meta);
    return () => {
      document.title = prevTitle;
      meta.remove();
    };
  }, []);

  useEffect(() => {
    if (shown > LINES.length) return;
    const timer = setTimeout(() => setShown(n => n + 1), shown === 0 ? 300 : 550);
    return () => clearTimeout(timer);
  }, [shown]);

  const done = shown > LINES.length;

  return (
    <div className="ad-page">
      <pre className="ad-log" aria-hidden={done}>
        {LINES.slice(0, shown).map((line, i) => (
          <div key={i}>{line}</div>
        ))}
        {!done && <span className="ad-cursor" />}
      </pre>

      {done && (
        <main className="ad-punch">
          <h1>haha, you’re funny</h1>
          <p>There is no admin panel here. There never was.</p>
          <a href="/">← back to levandox</a>
        </main>
      )}
    </div>
  );
}
